export default () => ({
    isLoading: true,
    items: [],
    categories: [],
    item: {},
    activeId: 1,
    restaurant: {},
    recommends: []
})
